import {
  getStorageEnvLabel,
  getWeightUnitLabel
} from "../internalStorage.utils";

interface InternalStorageOriginalDataPanelProps {
  originalData: any;
  searchFacilities: Array<{ id: string | number; title: string }>;
}

const InternalStorageOriginalDataPanel = ({
  originalData,
  searchFacilities
}: InternalStorageOriginalDataPanelProps) => {
  if (!originalData) {
    return null;
  }

  const warehouseName =
    searchFacilities.find(facility => String(facility.id) === String(originalData?.facilityId))
      ?.title || "";

  const rows = [
    { label: "Internal Storage Name", value: originalData?.internalStorageName },
    { label: "Data Type", value: originalData?.dataType },
    { label: "Storage Environment", value: getStorageEnvLabel(originalData?.storageEnv) },
    { label: "Warehouse Name", value: warehouseName },
    { label: "Storage Temperature (℃)", value: originalData?.storageTemperature },
    { label: "Warehouse size (m3)", value: originalData?.warehouseSize },
    {
      label: "Weight",
      value: `${originalData?.weight ?? ""} ${getWeightUnitLabel(originalData?.weightUnit)}`.trim()
    },
    { label: "Electricity (kWh/hr)", value: originalData?.electricity },
    { label: "Utilization of warehouse %", value: originalData?.utilizationOfWarehouse },
    { label: "Storage day(s)", value: originalData?.storageDays }
  ];

  return (
    <div className="tw-rounded-lg tw-border tw-border-border tw-bg-secondary/20 tw-p-4 tw-space-y-3">
      <p className="tw-text-sm tw-font-semibold tw-text-foreground">Original mapping data</p>
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3">
        {rows.map(row => (
          <div key={row.label}>
            <p className="tw-text-xs tw-text-muted-foreground">{row.label}</p>
            <p className="tw-text-sm tw-text-foreground">{row.value ?? "—"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InternalStorageOriginalDataPanel;
